import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CancelSubscriptionProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  addonName?: string;
}

const CancelSubscription: React.FC<CancelSubscriptionProps> = ({ 
  open, 
  onClose, 
  onConfirm,
  addonName = "Add On" 
}) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{
      "& .MuiDialog-paper": {
        maxWidth: "492px",
        borderRadius: "16px",
        position:"relative",
      },
    }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "22px",
              md: "18px",
            },
            fontWeight: "500",
            color: "#333333",
          }}
        >
          Cancel Subscription
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "#666",
            position:"absolute",
            top:"11px",
            right:"11px",
            "&:hover": {
              color: "#000",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: '0 32px 32px' }}>
        <Typography fontSize='16px' paddingTop='12px' color='#475467'>
          Are you sure you want to cancel the {addonName} subscription?
        </Typography>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "16px 24px",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          sx={{
            textTransform: "capitalize",
            padding: "8px 18px",
            bgcolor: "#E8E8EA",
            borderRadius: "8px",
            border: "1px solid #E8EAF0",
            color: "#344054",
            mr: "16px",
          }}
        >
          No, Keep
        </Button>
        <Button
          color="secondary"
          onClick={onConfirm}
          sx={{
            textTransform: "capitalize",
            marginLeft: "16px",
            padding: "8px 26px",
            borderRadius: "8px",
            bgcolor: "#E44258 !important",
            color: "#FFFFFF"
          }}
        >
          Yes Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelSubscription;
